import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./vertical_slide_cards.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import ReactDOM from 'react-dom';
import CardElement from "./card_item/card_element";
import {extraSmallLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";


class VerticalSlideCards extends TemplateComponent {

constructor(props) {
    super(props);
    this.cardsRefs = React.createRef();
    this.state = {
        active: 0,
        next: 0,
        slideIndex: 1,
        updateCount: 0
    }
}

componentRender(data){

    /*Slider 1*/
    const sliderSettingsSlideCards = {
        vertical: true,
        verticalSwiping: true,
        draggable: true,
        dots: false,
        variableWidth: false,
        centerMode: false,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        asNavFor: this.slider2,
        beforeChange: (currIndex, nextIndex) => {

            if (this.cardsRefs && this.cardsRefs[nextIndex]) {
                let nextCard = (ReactDOM.findDOMNode(this.cardsRefs[nextIndex].current));
                nextCard.classList.add("active");
                if (nextIndex > currIndex) {
                    (ReactDOM.findDOMNode(this.cardsRefs[currIndex].current)).classList.add("hidden");
                } else {
                    nextCard.classList.remove("hidden");
                }
            }
        },
        afterChange: (index) => {
            this.setState({active: index, next: null, slideIndex: this.state.updateCount + (index + 1)});
        },
        responsive: [
            {
                breakpoint: 950,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    variableWidth: true,
                    centerMode: false,
                    rows: 1,
                    infinite: true,
                    arrows: false
                }
            }
        ]
    };

    /*Slider 2*/
    const sliderSettingsSlideContent = {
        vertical: true,
        verticalSwiping: true,
        draggable: false,
        dots: false,
        variableWidth: false,
        centerMode: false,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        asNavFor: this.slider1,
        beforeChange: (currIndex, nextIndex) => {

            if (this.cardsRefs && this.cardsRefs[nextIndex]) {
                let nextCard = (ReactDOM.findDOMNode(this.cardsRefs[nextIndex].current));
                nextCard.classList.add("active");
                if (nextIndex > currIndex) {
                    (ReactDOM.findDOMNode(this.cardsRefs[currIndex].current)).classList.add("hidden");
                } else {
                    nextCard.classList.remove("hidden");
                }
            }
        },
        afterChange: (index) => {
            this.setState({active: index, next: null, slideIndex: this.state.updateCount + (index + 1)});
        }
    };

if (!this.cardsRefs) {
    this.cardsRefs = data.cards.map(() => React.createRef());
}

return (
    <div className={extraSmallLayout() ? "main-container-sliders-vertical mobile" : "main-container-sliders-vertical desktop"}>

        {/*Slider 1 contains vertical small card */}
        <div id={'vertical-slide-cards'}>
            <Slider ref={slider => (this.slider1 = slider)} className="vertical-slider-cards" {...sliderSettingsSlideCards}>
                {
                    data.cards.map((cardData, index) =>
                        <div key={index}> {/*data-aos="fade-up-left" data-aos-offset="50"*/}
                            <CardElement key={`card-${index}`} title={cardData.title} label={cardData.cta_label} text={cardData.text} url={cardData.cta_url}
                                         focused={index===this.state.active || index===this.state.next} ref={this.cardsRefs[index]}
                                         hidden={(!this.state.next || index < this.state.next) && index < this.state.active}/>
                        </div>
                    )
                }
            </Slider>
            {/* Range Slider */}
            <div className="vertical-container-range-slider">
                <input
                    className="progressive-slider-small-card"
                    onChange={event => this.slider1.slickGoTo(event.target.value)}
                    value={this.state.slideIndex}
                    type="range"
                    min="1"
                    max={data.cards.length}
                />
            </div>
        </div>

        {/*Slider 2 contains content right*/}
        <div id={'vertical-slide-content'}>
            <Slider ref={slider => (this.slider2 = slider)} className="vertical-slider-cards" {...sliderSettingsSlideContent}>
                {
                    data.cards.map((cardData, index) =>
                        <div key={index}>
                            <div className={'content-wrap'} {...insertHtml(cardData.content)} />
                        </div>
                    )
                }
            </Slider>
        </div>

    </div>
);
}
}

export default VerticalSlideCards;